import { render } from "./MessageNotification.vue?vue&type=template&id=1c4c7749"
import script from "./MessageNotification.vue?vue&type=script&lang=js"
export * from "./MessageNotification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MessageNotification.vue"]])

export default __exports__